import {COLORS, MAIN_PRIMARY_1_COLOR} from 'shared/consts';
import styled, {css} from 'styled-components';
import {toRem} from 'shared/helpers';

const BaseWrap = styled.div`
  position: absolute;
  bottom: 56px;
  left: calc(100% + 4px);
  width: min(365px, 20vw);
  border-radius: 16px;
  box-shadow:
    0px 32px 32px 0px var(--shadow-soft, rgba(88, 93, 105, 0.05)),
    0px 0px 32px 0px var(--shadow-muted, rgba(88, 93, 105, 0.1));
  background: ${COLORS.BG.PAGE_FILLED};
  padding: 24px 16px 16px;
  z-index: 11;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AnimatedWrap = styled(BaseWrap)`
  &.hud-slide-enter {
    opacity: 0;
    transform: translateX(-12px);
  }
  &.hud-slide-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition:
      opacity 200ms ease,
      transform 200ms ease;
  }
  &.hud-slide-exit {
    opacity: 1;
    transform: translateX(0);
  }
  &.hud-slide-exit-active {
    opacity: 0;
    transform: translateX(-12px);
    transition:
      opacity 150ms ease,
      transform 150ms ease;
  }
`;

export const AnimatedWrapTg = styled(AnimatedWrap)`
  padding: 0;
  width: fit-content;
  left: calc(100% + 30px);
`;

export const AnimatedWrapLogout = styled(AnimatedWrap)`
  padding: 0;
  bottom: 50%;
  left: calc(240px + (100vw - 240px - 280px) / 2);
`;

export const ProfileModalHeaderWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${toRem(24)};

  > img {
    border-radius: 50%;
  }

  > :first-child {
    margin-bottom: ${toRem(12)};
  }
`;

export const Title = styled.div`
  color: var(--fg-default, rgba(16, 24, 40, 0.75));
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
`;

export const Subtitle = styled.div`
  color: var(--fg-soft, rgba(16, 24, 40, 0.75));
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const EditProfileNavWrapper = styled.div`
  background: ${COLORS.BG.ELEVATED.XL};
  width: 100%;
  border-radius: 16px;

  > * {
    width: 100%;
  }

  > :first-child {
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
  }

  > :last-child {
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
  }

  @media (width < ${toRem(768)}) {
    margin-top: ${toRem(12)};
  }
`;

export const ProfileDrawerWrapper = styled.div`
  background-color: ${COLORS.BG.SURFACE3};
  height: 100%;
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;

  @media (width < ${toRem(400)}) {
    width: 100vw;
  }
  @media (width >= ${toRem(400)}) {
    width: ${toRem(400)};
  }
  @media (width >= ${toRem(992)}) {
    width: ${toRem(520)};
  }
  @media (width >= ${toRem(1200)}) {
    width: ${toRem(640)};
  }
`;

export const ProfileDrawerContent = styled.div`
  display: flex;
  gap: 16px;
  margin: ${toRem(16)} 0;

  @media (width < ${toRem(768)}) {
    margin-top: 0;
  }
`;

export const HLine = styled.div`
  width: ${toRem(608)};
  position: relative;
  left: ${toRem(-16)};
  min-height: 1px;
  background-color: ${COLORS.BORDER.MUTED};

  @media (width < ${toRem(768)}) {
    width: 100vw;
  }
`;

export const HLineLight = styled.div`
  width: 100%;
  min-height: 1px;
  background-color: ${COLORS.BORDER.MUTED};
  order: 4;
`;

export const ProfileDrawerHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  //border-bottom: 1px solid ${COLORS.BORDER.MUTED};
`;

export const ProfileDrawerTitle = styled.div`
  font-size: ${toRem(24)};
  font-weight: 700;
  margin: ${toRem(12)} 0 ${toRem(16)};
`;

export const ProfileImageWrapper = styled.div`
  background: ${COLORS.BG.ELEVATED.XL};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  padding: ${toRem(16)};
  gap: ${toRem(12)};
  align-items: center;
  height: min-content;

  > img {
    border-radius: 50%;
    background-color: ${COLORS.BG.ELEVATED.L};
  }
`;

export const NewEntryFileWrapper = styled.div`
  position: relative;
  width: min-content;
  height: min-content;
  //display: grid;
  //grid-template-columns: repeat(auto-fit, ${toRem(56)});
  //gap: ${toRem(4)};
  //flex: 1 1 auto;

  input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    //width: 0;
    //height: 0;
    opacity: 0;
  }
`;

export const ProfileContentWrapper = styled.div`
  background: ${COLORS.BG.ELEVATED.XL};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: ${toRem(16)};
  gap: ${toRem(16)};
  flex: 1;
`;

export const MobileProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${COLORS.BG.ELEVATED.XL};
  margin-top: ${toRem(8)};
  margin-bottom: ${toRem(16)};
  padding: ${toRem(16)};
  gap: ${toRem(16)};
  border-radius: ${toRem(16)};
`;

export const ProfileField = styled.div`
  display: flex;
  flex-direction: column;
  > :first-child {
    color: ${COLORS.FG.SOFT};
    font-size: ${toRem(12)};
    line-height: ${toRem(16)};
  }
  > :last-child {
    color: ${COLORS.FG.DEFAULT};
    font-size: ${toRem(16)};
    line-height: ${toRem(20)};
  }
`;

export const ProfileDrawerFooter = styled.div`
  display: flex;
  margin-top: auto;
  flex-direction: column;
  gap: ${toRem(16)};
`;

export const ControlsWrapper = styled.div<{$asidePadding?: boolean}>`
    display: flex;
    gap: ${toRem(16)};
    order: 7;
    
    @media (width < ${toRem(768)}){
        flex-direction: column;
        padding: ${toRem(16)} ${(props) => toRem(props.$asidePadding ? 16 : 0)} ${toRem(16)} ${(props) => toRem(props.$asidePadding ? 16 : 0)}};
        gap: ${toRem(16)};
        width: 100%;

        > :first-child {
            order: 2;
        }
    }
`;

export const ButtonContainer = styled.button<{
  $active?: boolean;
  $isMobileMenu?: boolean;
}>`
  display: flex;
  position: relative;
  left: 0;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  color: var(--fg-soft, rgba(16, 24, 40, 0.75));
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  gap: 15px;
  padding: 8px 12px;
  .edit-button {
    padding: 4px;
    position: absolute;
    right: 12px;
    top: 8px;
    width: var(--iconbutton-s-height, 24px);
    height: var(--iconbutton-s-height, 24px);

    display: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    border-radius: var(--iconbutton-s-border-radius, 8px);
    background: var(--iconbutton-ghost-neutral-bg-color-hover, rgba(88, 93, 105, 0.1));

    @media screen and (max-width: 1000px) {
      display: flex;
    }
  }

  &:hover {
    background: var(--neutral-container-muted, rgba(88, 93, 105, 0.03));

    .edit-button {
      display: flex;
    }
  }

  transition:
    background 0.3s ease-in-out,
    color 0.3s ease-in-out;

  &:hover {
    background: var(--neutral-container-soft, rgba(88, 93, 105, 0.05));
  }

  @media (width < ${toRem(768)}) {
    > :last-child {
      position: absolute;
      right: ${toRem(16)};
    }
  }

  ${({$active}) =>
    $active
      ? css`
          background: var(--accent-container-soft, rgba(255, 79, 18, 0.05));
          color: var(--accent-default, rgba(255, 79, 18, 1));
          &:hover {
            background: var(--accent-container-soft, rgba(88, 93, 105, 0.05));
          }
        `
      : css``}

  ${({$isMobileMenu}) =>
    $isMobileMenu
      ? css`
          flex-direction: column;
          align-items: center;
          gap: 2px;
          justify-content: center;
          width: 100%;

          font-size: 10px;
          line-height: 12px;
        `
      : css``}
`;

export const MobileSettingsWrapper = styled.div`
  position: fixed;
  top: ${toRem(56)};
  left: 0;
  max-width: 100vw;
  right: 0;
  height: calc(100dvh - ${toRem(56)} - ${toRem(54)});
  background-color: ${COLORS.BG.PAGE_FILLED};
  padding: 0 ${toRem(16)} ${toRem(16)};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  overflow-x: clip;
  z-index: 11;
  gap: 10px;

  > :nth-child(2) {
    min-width: 100%;
  }
`;

export const FishText = styled.div`
  text-align: center;
  font-size: ${toRem(14)};
  line-height: ${toRem(20)};
  margin-top: ${toRem(16)};
  color: ${COLORS.FG.SOFT};
`;

export const ProfileEditorForm = styled.form`
  height: 100%;
  width: 100%;
  gap: ${toRem(16)};
  display: flex;
  flex-direction: column;
`;

export const TransparentProfileImageWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${toRem(12)};
  margin-top: ${toRem(16)};

  > img {
    border-radius: 50%;
    margin-bottom: ${toRem(12)};
  }

  > :nth-child(2) {
    margin: 0;
    padding: 0;
  }
`;

export const TgContactWrapper = styled.div`
  width: ${toRem(366)};
  max-height: 90vh;
  height: max-content;
  overflow: auto;
  border-radius: ${toRem(16)};
  padding: ${toRem(16)};
  background-color: ${COLORS.BG.PAGE};
  gap: 16px;

  display: flex;

  button {
    flex-shrink: 0;
  }

  textarea {
    font-size: 16px;
  }

  flex-direction: column;
`;

export const ContactTitle = styled.h4`
  color: ${COLORS.FG.DEFAULT};

  font-size: 20px;
  font-weight: 700;
  line-height: 28px;

  &:not(:first-of-type) {
    margin-top: 8px;
  }
`;

export const ContactLink = styled.a`
  color: ${COLORS.FG.SOFT};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const SettingsTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: ${toRem(24)};
  margin-bottom: ${toRem(20)};
  padding: ${toRem(4)} 0 0 ${toRem(12)};
  grid-area: 1/2/1/2;
  align-self: center;
  @media screen and (max-width: 1000px) {
    justify-self: center;
  }
`;

export const StyledSectionHeader = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 24px 1fr 24px;
  grid-template-rows: auto;
  justify-content: space-between;
  min-width: 100vw;
  flex-direction: row;
  align-items: center;
  padding: ${toRem(16)};

  > div {
    margin: 0;
    padding: 0;
  }

  > button {
    grid-area: 1/3/1/3;
  }
`;

export const SettingsControlsWrapper = styled.div`
  background: ${COLORS.BG.ELEVATED.XL};
  width: 100%;
  border-radius: 16px;

  > * {
    width: 100%;
  }

  @media (width < ${toRem(768)}) {
    margin-top: ${toRem(16)};
  }
`;
export const SettingsDrawerWrapper = styled.div`
  display: flex;
  background: ${COLORS.BG.SURFACE1};
`;

export const LeftSectionWrapper = styled.div`
  border-right: 1px solid ${COLORS.BORDER.MUTED};
  height: 100vh;
  padding: ${toRem(16)} ${toRem(8)};
  width: ${toRem(240)};
`;

export const RightSectionWrapper = styled.div`
  padding: ${toRem(16)};
  width: ${toRem(400)};
  display: flex;
  flex-direction: column;
`;
export const ThemeTogglerWrapper = styled.div`
  position: relative;
  width: ${toRem(160)};
  //width: ${toRem(249)};
  height: ${toRem(36)};
  padding: 2px;
  border: none;
  border-radius: 12px;
  background-color: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};

  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: ${toRem(16)};
`;

export const ThemeToggleThumb = styled.div<{
  $position: number;
  $scale: number;
}>`
  width: 87px;
  height: 32px;
  border-radius: 11px;
  transition: transform 0.3s ease;
  position: absolute;
  background-color: ${COLORS.BG.SURFACE1};

  transform: translateX(${(props) => props.$position}px) scaleX(${(props) => props.$scale});
`;

export const ThemeControlsWrapper = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  font-size: ${toRem(14)};
`;
export const SettingsSectionContent = styled.div`
  margin: ${toRem(8)} 0 0 ${toRem(4)};
`;

export const SettingsSectionTitle = styled.div`
  font-size: ${toRem(16)};
  font-weight: 500;
  margin-bottom: ${toRem(24)};
`;

export const SettingsSectionText = styled.div`
  font-size: ${toRem(14)};
  font-weight: normal;
  margin-top: ${toRem(16)};
  line-height: ${toRem(20)};
`;

export const ThemeRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${toRem(16)};
  background-color: ${COLORS.BG.ELEVATED.S};

  > :first-child {
    border-top-right-radius: ${toRem(16)};
    border-top-left-radius: ${toRem(16)};
    border-bottom: 1px solid ${COLORS.BORDER.MUTED};
  }

  > :last-child {
    border-bottom-right-radius: ${toRem(16)};
    border-bottom-left-radius: ${toRem(16)};
    border-top: 1px solid ${COLORS.BORDER.MUTED};
  }
`;

export const ThemeRadioButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${toRem(52)};
  padding: ${toRem(16)};
  font-size: ${toRem(16)};
`;

export const Radio = styled.div<{$active: boolean}>`
  width: ${toRem(24)};
  height: ${toRem(24)};
  border-radius: 50%;
  border-width: ${(props) => (props.$active ? 6 : 3)}px;
  border-style: solid;
  border-color: ${(props) => (props.$active ? MAIN_PRIMARY_1_COLOR : COLORS.BORDER.MUTED)};
`;

export const TzList = styled.div`
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TzItem = styled.button<{$active?: boolean}>`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  font-size: ${toRem(14)};
  height: 36px;

  padding: 8px 12px;
  border-radius: 8px;

  border: 0;
  background: ${({$active}) => ($active ? `${COLORS.ACCENT.CONTAINER_SOFT}` : 'transparent')};
  color: ${({$active}) => ($active ? `${MAIN_PRIMARY_1_COLOR}` : `${COLORS.FG.DEFAULT}`)};

  cursor: pointer;
  transition:
    background 120ms ease,
    color 120ms ease;

  &:focus-visible {
    outline: 2px solid rgba(255, 92, 0, 0.45);
    outline-offset: 2px;
  }
`;
